import { Box, Typography } from "@mui/material";
import packageJson from "../../package.json"; // Adjust the path based on your file structure
export default function Footer() {
  return (
    <Box>
      <Typography fontSize={"12px"}  color="textSecondary" textAlign={"center"}>
       v{packageJson.version}
      </Typography>
      <Typography fontSize={"12px"} color="textSecondary" textAlign={"center"}>
        {"Copyright © "}
        PRECURE ApS {new Date().getFullYear()}
      </Typography>
    
    </Box>
  );
}
